<script lang="ts">
	import { onDestroy } from "svelte";

	import { confirmation } from ".";

	export let question = confirmation.question;
	export let showDialog = confirmation.showDialog;
	export let result = confirmation.result;
	export let unsubscribe = confirmation.unsubscribe;

	const yesFn = () => {
		result.set(true);
		showDialog.set(false);
	};

	const noFn = () => {
		result.set(false);
		showDialog.set(false);
	};

	onDestroy(() => {
		unsubscribe();
	});
</script>

{#if $showDialog === true}
	<div class="modal-backdrop-custom" />

	<div class="modal">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">Potvrdenie</div>

				<div class="modal-body">
					{@html $question}
				</div>

				<div class="modal-footer">
					<button class="btn btn-primary" on:click={yesFn}>Áno</button>
					<button class="btn btn-secondary" on:click={noFn}>Nie</button>
				</div>
			</div>
		</div>
	</div>
{/if}

<style>
	.modal-backdrop-custom:before {
		content: "";
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #000;
		opacity: 0.7;
	}

	.modal {
		display: block;
	}
</style>
